import { render, staticRenderFns } from "./AddEditRuleModal.vue?vue&type=template&id=191006f0"
import script from "./AddEditRuleModal.vue?vue&type=script&lang=js"
export * from "./AddEditRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports